import { type FC, useEffect } from "react";
import { Activity } from "lucide-react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAuthCta } from "../../utils/gluceraTypography";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const ThankYouPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionData = SessionStorageHelper.getAllData();
    // Assessment completion status checked
  }, []);

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 p-4">
          <BrandLogo />
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col items-center justify-center px-4 py-4 text-center sm:px-6">
          {/* Activity Icon */}
          <div className="mb-6 sm:mb-8">
            <Activity
              className="mx-auto h-12 w-12 text-primary sm:h-16 sm:w-16"
              strokeWidth={2}
            />
          </div>

          {/* Text Content */}
          <div className="space-y-1">
            <h1 className="text-large-title font-bold text-foreground sm:text-4xl">
              Thank You
            </h1>
            <p className="text-callout text-foreground sm:text-title3">
              For Trusting Us
            </p>
          </div>

          <p className="mx-auto max-w-xs pt-3 text-caption1 leading-relaxed text-muted-foreground sm:pt-4 sm:text-subhead">
            We promise to always keep your personal information private and
            secure.
          </p>
        </div>

        {/* Footer Button */}
        <div className="pb-safe p-4">
          <Button
            onClick={() =>
              navigate("/glucera" + GluceraNavigationRoutes.appdevicespage)
            }
            className={gluceraAuthCta}
          >
            Create My Plan
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
